module.exports = __webpack_public_path__ + "img/1488702821.9d4fb656.jpg";